module.exports = __webpack_public_path__ + "static/scheduled-repeat-campaigns-2f08656c96305e63a723b8d620a45e6f.svg";